if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        TextareaControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-opportunity', {
        // built-in attributes
        title: 'Card Opportunity',
        description: 'Custom Card Opportunity',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            }, 
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            viewMore: {
                type: 'string',
                default: 'SAZNAJTE VIŠE'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                image,
                alt,
                title,
                description,
                viewMore
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onSelectImage (image) {
                setAttributes({image: image.sizes.full.url});
            }

            function onAltChange(alt) {
                setAttributes({alt: alt});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            function onViewMoreChange(viewMore) {
                setAttributes({viewMore: viewMore});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                        <br />
                        <p><strong>Alt image:</strong></p>
                        <TextControl value={ alt } onChange={ onAltChange }></TextControl>
                        <br />
                        <p><strong>Enter url: (ex: /putovanja)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                        <br />
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <br />
                        <p><strong>Description</strong></p>
                        <TextareaControl value={ description } onChange={ onDescriptionChange }></TextareaControl>
                        <br />
                        <p><strong>Button</strong></p>
                        <TextControl value={ viewMore } onChange={ onViewMoreChange }></TextControl>



                    </PanelBody>
                </InspectorControls>
                ,
                <a class="card-opportunity d-block text-decoration-none">
                    <div class="card-img-container position-relative bg-dark shadow rounded overflow-hidden mb-2">
                        <img class="cover-image w-100 h-100" src={ image } alt={ alt }/>
                        <div class="position-absolute bottom-0 rounded p-4 text-white">
                            <RichText 
                                key="editable" 
                                tagName="h4" 
                                class="h5 card-title text-white text-shadow"
                                placeholder="TITLE" 
                                value={ title }
                                onChange={ onTitleChange }
                                style={ { color: '#fff' } } />
                            <RichText 
                                key="editable" 
                                tagName="p" 
                                class=""
                                placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nec ornare sapien eu est sociis phasellus hendrerit quam semper." 
                                value={ description }
                                onChange={ onDescriptionChange }
                                style={ { color: '#fff' } } />
                            <RichText 
                                key="editable" 
                                tagName="button" 
                                class="btn btn-sm btn-white bg-white rounded-pill px-3 text-primary fw-bold"
                                placeholder="SAZNAJTE VIŠE" 
                                value={ viewMore }
                                onChange={ onViewMoreChange } />
                        </div>
                    </div>
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                image,
                alt,
                title,
                description,
                viewMore
            } = attributes;

            return (
                <a href={ link } class="card-opportunity d-block text-decoration-none">
                    <div class="card-img-container position-relative bg-dark shadow rounded overflow-hidden mb-2">
                        <img class="lozad cover-image w-100 h-100" data-src={ image } alt={ alt } />
                        <div class="position-absolute bottom-0 rounded p-4 text-white">
                            <h5 class="card-title text-white text-shadow">{ title }</h5>
                            <RichText.Content 
                                tagName="p" 
                                class=""
                                value={ description } />
                            <button class="btn btn-sm btn-white bg-white rounded-pill px-3 text-primary fw-bold">{ viewMore }</button>
                        </div>
                    </div>
                </a>
            );
        },
    });
}